// QR 스크린샷은 폰 해상도에 따라 수 MB 일 수 있어 다운스케일 후 디코딩(성능).
const MAX_DECODE_DIMENSION = 1500

// 이미지 파일/Blob → ImageData (canvas 픽셀 추출). 클립보드 이미지도 Blob 이라 그대로 받는다.
export default async function imageFileToImageData(file) {
  const bitmap = await createImageBitmap(file)
  const scale = Math.min(1, MAX_DECODE_DIMENSION / Math.max(bitmap.width, bitmap.height))
  const width = Math.max(1, Math.round(bitmap.width * scale))
  const height = Math.max(1, Math.round(bitmap.height * scale))

  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height
  const ctx = canvas.getContext('2d')
  if (!ctx) throw new Error('CANVAS_2D_UNAVAILABLE') // 호출측 catch 가 "QR 없음" 으로 안내
  ctx.drawImage(bitmap, 0, 0, width, height)
  bitmap.close?.()
  return ctx.getImageData(0, 0, width, height)
}
